var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cloneDeep } from "lodash";
import sentry from "@irati/utils/services/sentry";
import { feedPollQuery } from "../query/FeedPoll";
import { feedRecognitionQuery } from "../query/FeedRecognition";
import { FeedItemType, FeedVisibility } from "../../enums";
export var updateFeeds = function (item) {
    var _a;
    var isEverything = true;
    var isMyTeam = item.private || item.teams.results.length > 0;
    var isPrivate = item.private;
    var feeds = Object.freeze((_a = {},
        _a[FeedVisibility.EVERYTHING] = isEverything,
        _a[FeedVisibility.MY_FEED] = isMyTeam,
        _a[FeedVisibility.JUST_ME] = isPrivate,
        _a));
    return function (updater) {
        Object.keys(feeds).forEach(function (feed) {
            var shouldBeUpdated = feeds[feed];
            if (shouldBeUpdated) {
                try {
                    updater(feed);
                }
                catch (e) {
                    sentry.captureException(e);
                }
            }
        });
    };
};
export var addItemToFeed = function (feed, newItem) {
    if (!newItem) {
        return feed;
    }
    var clonedItem = cloneDeep(newItem);
    var clonedFeed = cloneDeep(feed);
    clonedFeed.results.unshift(clonedItem);
    return clonedFeed;
};
export var getFeedItemQueryByType = function (type, parentId) {
    if (type !== FeedItemType.POLL && type !== FeedItemType.RECOGNITION) {
        return null;
    }
    var query = type === FeedItemType.POLL ? feedPollQuery : feedRecognitionQuery;
    return __assign(__assign({}, query), { variables: {
            id: parentId
        } });
};
export var getItemType = function (item) { return ("receivers" in item ? FeedItemType.RECOGNITION : FeedItemType.POLL); };
var RECOGNITION_FEED_ITEM_TYPE = "RecognitionFeed";
export var getFeedEntityFromRecognition = function (recognition) { return ({
    __typename: RECOGNITION_FEED_ITEM_TYPE,
    uuid: recognition.uuid,
    type: FeedItemType.RECOGNITION,
    recognition: recognition,
    poll: null
}); };
export var getFeedItemFromPoll = function (poll) { return ({
    __typename: RECOGNITION_FEED_ITEM_TYPE,
    uuid: poll.uuid,
    type: FeedItemType.POLL,
    recognition: null,
    poll: poll
}); };
